import React, {useContext} from 'react';
import {observer} from 'mobx-react-lite';
import './Popup.scss';
import {StoreContext} from '../../helpers/StoreContext';

export default observer((props)=> {
  const displayStore = useContext(StoreContext).displayStore;


  return displayStore.showPopup.get() ? (<div className="aperture"><div className="popup">{displayStore.innerPopup}</div></div>) : (null);
});
